"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHandler = void 0;
const tslib_1 = require("tslib");
const http_helpers_1 = require("../http-helpers");
const POLYMARKET_COOKIE_NAME = "polymarket";
class AuthHandler {
    constructor(httpClient, args) {
        if (args.authUrl == undefined || args.authToken == undefined) {
            throw new Error("invalid authorization arguments");
        }
        this.url = args.authUrl.endsWith("/") ? args.authUrl.slice(0, -1) : args.authUrl;
        this.token = args.authToken;
        this.httpClient = httpClient;
    }
    /**
     * Logs in to the auth url
     * Extracts polymarket session cookies from the auth response header and cache it locally.
     */
    login() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.cookie == undefined) {
                // Logging in will set the session cookies on the httpClient
                const resp = yield this.httpClient.send(`${this.url}/login`, http_helpers_1.GET, { Authorization: `Bearer ${this.token}` });
                const cookies = resp.headers['set-cookie'];
                let aggregatedCookie = "";
                for (const cookie of cookies) {
                    if (cookie.includes(POLYMARKET_COOKIE_NAME)) {
                        aggregatedCookie += `${cookie}; `;
                    }
                }
                if (aggregatedCookie != "") {
                    this.cookie = aggregatedCookie;
                }
                console.log(`Successfully logged in!`);
            }
        });
    }
    getPolymarketCookies() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.cookie == undefined) {
                console.log("Authorization not set, logging in...");
                yield this.login();
            }
            return this.cookie;
        });
    }
}
exports.AuthHandler = AuthHandler;
